const blogPosts = [
    {
      id: 1,
      title: "Exploring Mountain Trails",
      author: "John Doe",
      date: "2024-05-01",
      content: "Join us as we explore some of the most breathtaking mountain trails. This journey takes you through serene woods and up to panoramic viewpoints.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 2,
      title: "A Day in the Life of a Hiker",
      author: "Jane Smith",
      date: "2024-05-02",
      content: "Ever wondered what it's like to spend a day hiking? In this post, we follow a hiker through their daily adventures on the trail.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 3,
      title: "Top 10 Hiking Tips for Beginners",
      author: "Emily White",
      date: "2024-05-03",
      content: "New to hiking? Check out our top 10 tips to help you get started and make the most of your outdoor adventures.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 4,
      title: "The Health Benefits of Hiking",
      author: "Michael Green",
      date: "2024-05-04",
      content: "Discover the numerous health benefits of hiking, from improved cardiovascular health to mental well-being.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 5,
      title: "Best Gear for Mountain Hiking",
      author: "Sarah Brown",
      date: "2024-05-05",
      content: "Wondering what gear you need for mountain hiking? We've compiled a list of essential items to ensure a safe and enjoyable hike.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 6,
      title: "How to Plan a Hiking Trip",
      author: "Alex Johnson",
      date: "2024-05-06",
      content: "Planning a hiking trip can be daunting. Follow our step-by-step guide to ensure your adventure is well-organized and memorable.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 7,
      title: "Hidden Gems: Underrated Hiking Trails",
      author: "Chris Lee",
      date: "2024-05-07",
      content: "Tired of crowded trails? Discover some of the lesser-known hiking spots that offer stunning views and a peaceful environment.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 8,
      title: "Hiking Safety Tips",
      author: "Lisa Kim",
      date: "2024-05-08",
      content: "Safety should always be a priority when hiking. Here are some essential safety tips to keep in mind before you hit the trails.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 9,
      title: "Hiking with Kids: What You Need to Know",
      author: "David Martin",
      date: "2024-05-09",
      content: "Hiking with kids can be a rewarding experience for the whole family. Learn how to prepare and make the hike enjoyable for children.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 10,
      title: "The Best Time of Year for Hiking",
      author: "Olivia King",
      date: "2024-05-10",
      content: "Different seasons offer unique hiking experiences. Find out the best time of year to hike and what to expect during each season.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 11,
      title: "Photography Tips for Hikers",
      author: "Nathan Brown",
      date: "2024-05-11",
      content: "Capture the beauty of your hiking adventures with these photography tips. Learn how to take stunning landscape photos on the trail.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 12,
      title: "Hiking Etiquette: Do's and Don'ts",
      author: "Emma Davis",
      date: "2024-05-12",
      content: "Good hiking etiquette helps ensure a pleasant experience for everyone. Learn the do's and don'ts of hiking to be a responsible hiker.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 13,
      title: "The Ultimate Guide to Long-Distance Hiking",
      author: "Megan Clark",
      date: "2024-05-13",
      content: "Long-distance hiking offers a unique challenge and reward. Learn how to prepare for and undertake extended hikes.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 14,
      title: "Hiking Solo: Finding Peace on the Trails",
      author: "Jack Wilson",
      date: "2024-05-14",
      content: "Hiking alone can be a peaceful and introspective experience. Discover the benefits and precautions of solo hiking.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 15,
      title: "Eco-Friendly Hiking: Leave No Trace",
      author: "Laura Adams",
      date: "2024-05-15",
      content: "Learn how to hike responsibly and minimize your environmental impact with these eco-friendly hiking tips.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 16,
      title: "Hiking for Mental Health",
      author: "Peter Harris",
      date: "2024-05-16",
      content: "Hiking isn't just good for your body; it's great for your mind too. Discover how hiking can improve your mental health.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 17,
      title: "Preparing for a Winter Hike",
      author: "Hannah Scott",
      date: "2024-05-17",
      content: "Winter hiking can be beautiful and challenging. Learn how to prepare for a safe and enjoyable winter hike.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 18,
      title: "Best Hiking Snacks and Meals",
      author: "George Allen",
      date: "2024-05-18",
      content: "Fuel your hike with the best snacks and meals. Discover easy and nutritious options to keep you energized on the trail.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 19,
      title: "Hiking in National Parks",
      author: "Isabella Morris",
      date: "2024-05-19",
      content: "Explore the beauty of national parks through hiking. Learn about the best trails and what to expect when hiking in these protected areas.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 20,
      title: "The History of Hiking",
      author: "Daniel Roberts",
      date: "2024-05-20",
      content: "Hiking has a rich history that spans cultures and centuries. Discover the origins and evolution of hiking as a popular activity.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 21,
      title: "Hiking Challenges: Conquering Tough Trails",
      author: "Michelle Wright",
      date: "2024-05-21",
      content: "Ready for a challenge? Learn about some of the toughest hiking trails and how to prepare for these demanding adventures.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    },
    {
      id: 22,
      title: "Hiking and Camping: The Perfect Combo",
      author: "Patricia Bell",
      date: "2024-05-22",
      content: "Combine hiking with camping for the ultimate outdoor experience. Learn how to plan and enjoy a hiking-camping trip.",
      imageUrl: "https://images.pexels.com/photos/18897226/pexels-photo-18897226/free-photo-of-wooden-footpath-along-woods-borderline-in-mountains.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
    }
  ];
  
export default blogPosts;  